<div class="insight-team-container">
    <app-loader class="loader" *ngIf="loaderView; else body"></app-loader>
    <ng-template #body>
        <app-super-admin-header workspaceRoute="/home/main/dashboard"
            insightsRoute="/home/main/insights"></app-super-admin-header>
        <!-- <button class="cancel-btn" (click)="handleCancel()">
            <img src="assets/24x24/arrow-left-circle.svg" alt="">
            <span>Back</span>
        </button> -->
        <div class="insight-wrapper">
            <div class="left-section">
                <div class="headings">
                    <div class="head">
                        <h3>Asset Types</h3>
                        <p>
                            <app-generic-search-dropdown [options]="options" [title]="title"
                                (value)="getWorkspace($event)" [shouldEmitdisplayValue]="true"
                                [titleName]="'name'"></app-generic-search-dropdown>
                        </p>
                    </div>
                </div>
                <div class="table-container" *ngIf="selectedOption === 'Show All'">
                    <table class="table" cdk-table [dataSource]="dataSource">
                        <ng-container cdkColumnDef="Workspaces">
                            <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                                Workspace
                            </th>
                            <td cdk-cell *cdkCellDef="let element" class="table-data do-flex">
                                <p class="count-with-asset-type asset-name">
                                    <span class="table-data">{{ element?.Workspace }}</span>
                                </p>
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="Asset Type Count">
                            <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                                Asset Types Count
                            </th>
                            <td cdk-cell *cdkCellDef="let element" class="table-data asset">
                                {{ element?.assetTypeCount }}
                            </td>
                        </ng-container>
                        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
                        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <ng-container *ngIf="count > 5">
                        <div class="row">
                            <div class="filter-wrapper">
                                <p class="filter-text">View Workspace Rows</p>
                                <app-generic-drop-down [label]="pageCount" (index)="pageSizeEmitter($event)"
                                    [options]="pageSizeOptions" [title]="pageCount || '5'" class="drop-down-container"
                                    [showDropContainerTop]="true" [shouldEmitIndex]="true">
                                </app-generic-drop-down>
                            </div>
                            <div>
                                <app-pagination (responseData)="paginationEmitter($event)"
                                    [recordsPerPage]="+pageCount || 5" [count]="count">
                                </app-pagination>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="table-container" *ngIf="selectedOption !== 'Show All'">
                    <table class="table" cdk-table [dataSource]="dataSource">
                        <ng-container cdkColumnDef="Asset Type Name">
                            <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                                Asset Types
                            </th>
                            <td cdk-cell *cdkCellDef="let element" class="table-data do-flex">
                                <p class="count-with-asset-type asset-name">
                                    <span class="table-data">{{ element?.assetTypeName }}</span>
                                </p>
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="Asset Count">
                            <th cdk-header-cell *cdkHeaderCellDef class="table-head">
                                Asset Count
                            </th>
                            <td cdk-cell *cdkCellDef="let element" class="table-data asset">
                                {{ element?.assetCount }}
                            </td>
                        </ng-container>
                        <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
                        <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <ng-container *ngIf="count > 5">
                        <div class="row">
                            <div class="filter-wrapper">
                                <p class="filter-text">View Workspace Rows</p>
                                <app-generic-drop-down [label]="pageCount" (index)="pageSizeEmitter($event)"
                                    [options]="pageSizeOptions" [title]="pageCount || '5'" class="drop-down-container"
                                    [showDropContainerTop]="true" [shouldEmitIndex]="true">
                                </app-generic-drop-down>
                            </div>
                            <div>
                                <app-pagination (responseData)="paginationEmitter($event)"
                                    [recordsPerPage]="+pageCount || 5" [count]="count">
                                </app-pagination>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="right-section">
                <div class="chart-container">
                    <div class="inner-container">
                        <div>Users</div>
                        <app-generic-search-dropdown [options]="options" class="search" [title]="title"
                        (value)="getValue($event)" [shouldEmitdisplayValue]="true"
                        [titleName]="'name'"></app-generic-search-dropdown>
                    </div>
                    <ng-container *ngIf="!isChartDataEmpty; else noUserData">
                        <canvas baseChart [data]="pieChartData" [type]="pieChartType"
                            [options]="pieChartOptions"></canvas>
                        <div class="center-text">
                            <div class="center-label">Total Users</div>
                            <div class="center-value">{{ rawData.totalUsers }}</div>
                        </div>
                    </ng-container>

                    <ng-template #noUserData>
                        <div class="no-data-chart">
                            <img src="assets/illustrations/no-data.svg" alt="No data available" />
                            <p>No user data available for the selected workspace.</p>
                        </div>
                    </ng-template>
                </div>
                <div class="chart-container-1">
                    <div class="name">Subscriptions</div>
                    <canvas baseChart [data]="subscriptionPieChart" [type]="pieChartType" [options]="pieChartOptions">
                    </canvas>

                    <div class="center-text-1">
                        <div class="center-label">Total Subscriptions</div>
                        <div class="center-value">{{ subscriptionData.count }}</div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>